export default __webpack_public_path__ + "static/media/ic_usdm_24.bafa9da6.svg";